import $ from 'jquery'
import { focusIsInsideOpenLayeredModal } from './bootstrap_modal_focus.mjs'

if ($.fn.modal) {
  // Extends the default hide event to trigger another 'hide-with-trigger-event' & pass the original trigger event
  const existingHide = $.fn.modal.Constructor.prototype.hide
  $.fn.modal.Constructor.prototype.hide = function (e) {
    const ev = $.Event('hide-with-trigger-event.bs.modal', { triggerEvent: e })
    this.$element.trigger(ev)
    if (ev.isDefaultPrevented && ev.isDefaultPrevented()) return
    existingHide.apply(this, arguments)
  }

  // Extend the default escape event to trigger hide() with the original keydown event
  //  i.e add `e` as the param to the `this.hide()` call below
  $.fn.modal.Constructor.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on(
        'keydown.dismiss.bs.modal',
        $.proxy(function (e) {
          e.which == 27 && this.hide(e)
        }, this)
      )
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  $.fn.modal.Constructor.prototype.setScrollbar = function () {
    // Bootstrap adds paddingRight when opening/hiding modals to try to prevent content shift.
    // But looks like for us it does the opposite (on chrome+arc atleast). It also doesn't work when multiple modals are involved.
  }

  // Bootstrap traps focus inside the open `.modal`. Tailwind ModalComponents
  // (prompt, confirm, …) render outside that tree. Without this exception,
  // nested inputs are unusable — e.g. lock-reason prompt over spam manager
  // (ENG-31953). Same class of bug as assets_dialog doing
  // `$(document).off('focusin.bs.modal')` for the image editor.
  $.fn.modal.Constructor.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on(
        'focusin.bs.modal',
        $.proxy(function (e) {
          if (
            document !== e.target &&
            this.$element[0] !== e.target &&
            !this.$element.has(e.target).length &&
            !focusIsInsideOpenLayeredModal(e.target)
          ) {
            this.$element.trigger('focus')
          }
        }, this)
      )
  }
}
